import React, {useEffect, useState} from 'react';
import {HtmlParse} from 'utils';
import PropTypes from 'prop-types'; 
import PubSub from 'services/PubSub/';
import style from './style.scss'; //NOSONAR

const Notification = (props) => {
    const [active, setActive] = useState(false);
    const timer = props.timer ? props.timer + 40 : '';

    useEffect(()=>{
        if(!timer){
            setActive(true);
        } else {
            setTimeout(() => {
                setActive(true);
            },40);

            setTimeout(() => {
                closeNotification();
            },timer);
        }
    },[]);

    const closeNotification = () => {
        setActive(false);

        if(!timer) {
            PubSub.dispatch('remove_snackbar',{index: props.index}); 
        } else {
            setTimeout(()=> {
                PubSub.dispatch('remove_snackbar',{index: props.index});
            }, 320);
        }
        
    }

    const clickAction = () => {
        props.callback();
        closeNotification();
    };

    const {TitleMobile, TitleDesktop, Subtitle, callback, titleButtonDesktop, titleButtonMobile, className, buttonDark} = props;

    return (
        <div className={"notification-session-container " + (className ? className : '') + (active ? " active" : '') } >
            <div className="notification-session-cont-span" >
                {TitleMobile && <span className="notification-session-expired-span-mobile">{TitleMobile}</span>}
                {TitleDesktop && <span className="notification-session-expired-span-desktop">{TitleDesktop}</span>}
                {Subtitle && <span className="notification-session-text-span">{HtmlParse(Subtitle)}</span>}
            </div>
            {callback && <div className={"notification-session-button-mobile" + (buttonDark ? ' dark' : '')} onClick={clickAction}>{titleButtonMobile}</div>}
            {callback && <div className={"notification-session-button-desktop" + (buttonDark ? ' dark' : '')} onClick={clickAction}>{titleButtonDesktop}</div>}
            <button className="notification-session-close" onClick={() => closeNotification()}></button>
        </div>
    )
}
Notification.propTypes = {
    callback: PropTypes.func,
    titleButtonMobile: PropTypes.string,
    titleButtonDesktop: PropTypes.string,
    TitleMobile: PropTypes.string,
    Subtitle: PropTypes.string,
    TitleDesktop: PropTypes.string,
    timer: PropTypes.number,
    index: PropTypes.number,
    className: PropTypes.string
}

export default Notification;
